import React from "react";

interface SidebarButtonProps {
    buttonClass: string;
    buttonText: string;
    active: boolean;
    setActive: () => void;
    name: string;
    icon?: React.ElementType;
}

const SidebarButton: React.FC<SidebarButtonProps> = (props) => {
    const { buttonClass, buttonText, active, setActive, name } = props;


    return (
        <button
            className={`${buttonClass} ${active ? "active" : ""} ${buttonText === "Logout" ? "logout-button" : ""}`}
            onClick={setActive}
            style={{
                marginTop: buttonText === "Logout" ? "auto" : undefined,
                // backgroundColor handled by CSS class
            }}
        >
            {props.icon ? <props.icon className="sidebar-icon-svg" /> : <i className={name}></i>}
            <span className="button-text">
                {buttonText}
            </span>
        </button >
    );
};

export default SidebarButton;
